'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TRIGGER = exports.TRIGGER = 'TRIGGER';
var REQUEST = exports.REQUEST = 'REQUEST';
var SUCCESS = exports.SUCCESS = 'SUCCESS';
var FAILURE = exports.FAILURE = 'FAILURE';
var FULFILL = exports.FULFILL = 'FULFILL';

exports.default = [TRIGGER, REQUEST, SUCCESS, FAILURE, FULFILL];


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga-routines/dist/routineStages.js
// module id = ./node_modules/redux-saga-routines/dist/routineStages.js
// module chunks = 2